import { render } from "./TaxillaValidatedInvoice.vue?vue&type=template&id=9c35abc8"
import script from "./TaxillaValidatedInvoice.vue?vue&type=script&lang=js"
export * from "./TaxillaValidatedInvoice.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/moko.africa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__